export default "__VITE_ASSET__CkEHFi0Y__"